
//v-pattern
export default {
    bind: (el: HTMLElement, binding, vnode, oldVnode) => {
        if ((el.tagName.toLowerCase() === 'input' && el.attributes.getNamedItem('type')?.value.toLowerCase() === 'text')
            || el.tagName.toLowerCase() === 'textarea') {
                el.addEventListener('keydown', ev => {
                    const input = ev.target as HTMLInputElement;
                    const valbefore = input.value;
                    console.log(valbefore)
                    setTimeout(() => {
                        if(!input.checkValidity()) {
                            input.value = valbefore;
                        }
                    }, 1);
                });
        }
    },
}